<template lang="pug">
div.box
    v-server-table(
        :url="api"
        :name="tableName"
        ref="datatable"
        :columns="columns"
        :options="options"
    )
        template(slot="beforeTable")
            datatable-loader(:name="tableName")
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import formattedCurrencyMixin from '@js/mixins/formatted-currency';
import { mapState } from 'vuex';

export default {
    mixins: [receiptMixin, formattedCurrencyMixin],

    data() {
        return {
            tableName: 'ABORTED_FUEL',
            columns: [
                'aborted_at',
                'receipt_number',
                'staff',
                'till_closure',
                'till_summary',
                'name',
                'total_amount',
                'outlet_name',
            ],
            options: {
                export_post: true,
                export_filename: 'Aborted Fuels Report',
                sortable: ['aborted_at'],
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                orderBy: {
                    ascending: false,
                    column: 'aborted_at',
                },
                texts: {
                    title: 'Aborted Fuels',
                    description: 'Shows list of aborted fuels',
                },
                headings: {
                    receipt_number: 'Receipt No.',
                    settled_date: 'Receipt Date',
                    staff: 'Staff',
                    aborted_at: 'Aborted At',
                    outlet_name: this.trans('general.outlet'),
                    total_amount: `Total Amount (${this.getCurrency()})`,
                    till_closure: 'Till Closure No.',
                    till_summary: 'Till Summary No.',
                    name: 'Product Name',
                },
                columnsClasses: {
                    total_amount: 'text-right',
                },
                templates: {
                    receipt_number: (h, row, col) => {
                        return this.receiptNumberFormat(row);
                    },

                    aborted_at: (h, row, col) => {
                        return this.receiptDateFormat(row.aborted_at);
                    },
                    settled_date: (h, row) => {
                        return this.receiptDateFormat(row.settled_date);
                    },
                    outlet_name: (h, row) => {
                        return row.outlet_name.substring(0, 20);
                    },
                },
                requestFunction: function(request) {
                    let req = Object.assign(request, {
                        typeDate: localStorage.getItem('timezones'),
                        timezoneDevice: Intl.DateTimeFormat().resolvedOptions()
                            .timeZone,
                    });

                    return axios
                        .post(this.url, req)
                        .catch(e => this.dispatch('error', e));
                },
                pdf_url: Laroute.route(
                    'franchise.report.voidedsales.abortedfuels.export',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.voidedsales.abortedfuels.export',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.voidedsales.abortedfuels.export',
                    { type: 'XLSX' },
                ),
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        api() {
            return Laroute.route('franchise.report.voidedsales.abortedfuels');
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },

        getActiveOutlet() {
            this.setColumnDisplay();
        },

        '$store.getters.currency'() {
            this.options.headings.total_amount = `Total Amount (${this.getCurrency()})`;
        },
    },

    mounted() {
        this.setColumnDisplay();
    },

    methods: {
        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        setColumnDisplay() {
            if (this.getActiveOutlet != 0) {
                this.$refs.datatable.userControlsColumns = true;
                this.$refs.datatable.userColumnsDisplay = [
                    'aborted_at',
                    'receipt_number',
                    'staff',
                    'till_closure',
                    'till_summary',
                    'payment_type',
                    'name',
                    'total_amount',
                ];
            } else {
                this.$refs.datatable.userColumnsDisplay = this.columns;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/voided/aborted-fuel-datatable.vue